export default {
  artistName: 'SANDRA DISCHNER',
  tagline: 'Zeitgenössische Kunst & Design',
  scrollIndicator: 'Scrollen zum Entdecken',
  all_rights: 'Alle Rechte vorbehalten.',
  back: '← Zurück',
  featuredWorks: 'Ausgewählte Werke',
  collectionDescription: 'Kuratiertes Portfolio aktueller Kunst',
  visualJourney: 'Visuelle Reise',
  contemporaryExpression: 'Gegenwärtige Ausdrucksform',
  artisticEvolution: 'Entwicklung der künstlerischen Handschrift',
  fromRegensburg: 'AUS REGENSBURG',
  withLoveToWorld: 'MIT ♥ IN DIE GANZE WELT',
  continueScrolling: 'Weiterscrollen',
  impressum: 'Impressum',
  artistInfo: 'Künstlerinformationen',
  websiteInfo: 'Website-Informationen',
  responsibleContent: 'Verantwortlich für Inhalte',
  odrHeading: 'Online-Streitbeilegung gemäß Artikel 14 Absatz 1 der Verordnung über Online-Streitbeilegung',
  odrText: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (ODR) bereit, die Sie unter folgendem Link finden',
  vsbgHeading: 'Hinweis gemäß § 36 des Verbraucherstreitbeilegungsgesetzes (VSBG)',
  vsbgText: 'Wir sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschiedsstellte teilzunehmen.',
  copyrightHeading: 'Urheberrecht',
  copyrightText: 'Der Inhalt und die Werke auf dieser Website unterliegen den Urhebergesetzen der geltenden Rechtsordnung. Jede Vervielfältigung, Verarbeitung, Verbreitung oder andere Nutzung, die über das Urheberrecht hinausgeht, bedarf der vorherigen schriftlichen Zustimmung des Autors oder des Rechteinhabers.',
  countryGermany: 'Deutschland',
  stateBayern: 'Bayern'
};
